import { AxiosSingleton, BaseError } from '@/common';
import { MetricEvent } from '@/features';
import { Axios } from 'axios';
import { container } from 'tsyringe';

export abstract class IMetricEventsDataSource {
  abstract createEvent(event: MetricEvent): Promise<string>;
}

export class RemoteMetricEventsDataSource implements IMetricEventsDataSource {
  api: Axios;

  constructor() {
    this.api = container.resolve(AxiosSingleton).ewaPublicBff;
  }

  async createEvent(event: MetricEvent): Promise<string> {
    try {
      const response = await this.api.post('/metric-events', { ...event, capturedAt: new Date().toISOString() });
      return response.data.url;
    } catch (error) {
      throw new BaseError('Failed to create metric event');
    }
  }
}
